import { IAPIAction } from "us.collection/interfaces";
import { CreditorApproval } from "us.collection.admin/constants/Actions";

export const creditorApprovalInfo: Readonly<IAPIAction> = {
  creditorApprovalList: {
    get: (data) => ({
      type: CreditorApproval.GET_CREDITORS_LIST_FOR_APPROVAL,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: CreditorApproval.GET_CREDITORS_LIST_FOR_APPROVAL_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: CreditorApproval.GET_CREDITORS_LIST_FOR_APPROVAL_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },


  creditorApproval: {
    save: (data) => ({
      type: CreditorApproval.APPROVE_CREDITOR,
      payload: {
        data: data,
        isLoading: true,
      },
    }),
    success: (data) => ({
      type: CreditorApproval.APPROVE_CREDITOR_SUCCESS,
      payload: {
        data: data,
        isLoading: false,
      },
    }),
    fail: (error) => ({
      type: CreditorApproval.APPROVE_CREDITOR_FAIL,
      payload: {
        error: error,
        isLoading: false,
      },
    }),
  },
};
